import { styled } from 'styled-components';

export const Wrapper = styled.div`
    background: #fff;
    border-width: 0 1px 1px;
    border-style: solid;
    border-color: #ececf0;
    border-radius: 12px;
    margin-bottom: 24px;

    :last-child {
        margin-bottom: 0;
    }
`;
